/* eslint-disable */

/**
 * API DocsHome Template
 * By Srinivasa Upputuri <supputuri@svb.com> (www.svb.com)
 * Summary
 * This component renders Api Docs Home Page
 */
import React, { Fragment }  from 'react';
import { useEffect, useState } from 'react';
import Markdown from 'markdown-to-jsx';
import { ArrowLink, SVBSlogans, PortalCard } from '@svb/svb-react-components';
import DocsHomeApisInvolved from './DocsHomeApisInvolved';
import { getDocsHomeDetails } from './helper';
import { SVBCTABlock } from '@svb/portal-ui-react-components';
import Loading from '@svb/api-loading-component/dist/components';
import MetaTags from '../../core/MetaTags';
import { SVBErrorPageRenderer } from '../../helpers/utilityFunctions';
import { useStore } from '../../core/useStore';
import { preLoadIntegratedSolutionsData, getImageMimeType } from '../integratedSolutions/helpers/utils';
import HomepageBannerNotification from '../notification/HomepageBannerNotification';

/**
 * DocsHome
 * @param contentUrl: url of the docs home md content
 * @returns DocsHome Page with Header, Widget Cards and Api Cards
 */
const DocsHome = ({ dataTestId, testMockContent, ...props }) => {
  const { contentUrl } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [ismounted, setIsmounted] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorStatusCode, setErrorStatusCode] = useState('');
  const [errorDefaultMessage, setErrorDefaultMessage] = useState(
    'It happens sometimes, you may refresh the page or go to home.',
  );
  const { loading, sectionsLogoMap, cardsConfig, cardsLogoMap } = useStore(
    (state) => state.integratedSolData,
  );
  // const supportFaqsItems = useStore((state) => state.faqsItems);
  // let url = props?.contentUrl ? props?.contentUrl : '';

  const docHomeDetails = dataTestId
    ? testMockContent
    : getDocsHomeDetails(contentUrl, 'docs-home.md');

  useEffect(() => {
    setIsmounted(true);
  }, []);

  useEffect(() => {
    setIsError(false);
    if (docHomeDetails.type === 'success') {
      setIsLoading(false);
    }

    if (docHomeDetails.type === 'error') {
      setIsError(true);
      setErrorStatusCode(docHomeDetails?.errorStatusCode);
      !docHomeDetails?.errorStatusCode && setErrorDefaultMessage(docHomeDetails?.response);
      setIsLoading(false);
    }
  }, [docHomeDetails.response]);

  useEffect(() => {
    if (!cardsConfig) {
      preLoadIntegratedSolutionsData(contentUrl);
    }
  }, [contentUrl, cardsConfig]);


  const DocsHero = ({ ...props }) => {
    return (
        <section className='hero-section d-flex justify-content-center align-items-center'>
          <div className='container svb-container-fixed'>
            <div className='hero-content mx-3 text-center text-sm-start'>
            <h1 className='hero-title mb-3 text-reset'>{props?.title}</h1>
            <p className='hero-description mb-4 text-reset'>
              {props?.description}
            </p>
            <div className='mb-4 row justify-content-center justify-content-sm-start g-4'>
              {cardsConfig?.sections.slice(0,4).map(item=>  (
                <div className='col-auto' key={item.title}>
                  <PortalCard
                    data={{
                      title: item.title,
                      logo: {
                        type: 'image',
                        src:
                          sectionsLogoMap[item.logo] &&
                          `data:${getImageMimeType(item.logo)};base64,${sectionsLogoMap[item.logo]}`,
                        alt: `${item.title} logo`,
                        position: 'center',
                        size: 32
                      },
                    }}
                    className="hero-card text-center"
                  />
                </div>
              ))}

            </div>
            <ArrowLink className="neutral-color" text="Browse Integrated Solutions" href="/integrated-solutions"/>
          </div>
          </div>
        </section>
    );
  };

  if (isError) {
    return (
      <SVBErrorPageRenderer
        errorStatusCode={errorStatusCode}
        defaultErrorMessage={errorDefaultMessage}
      />
    );
  }
  return (
    <>
      {/*Generate metadata once component/template mounts */}
      {ismounted && (
        <MetaTags
          title={'Home'}
          sitename={'First Citizens Bank Developer Portal'}
          description={
            'Guides, Specifications, and other developer resources to help you build with our APIs'
          }
          image={window.location.protocol + '//' + window.location.host + '/FirstCitizensBankLogo.png'}
          keywords={
            'svb, first citizens bank, api, developer, portal, integration, fcb, first citizens, documentation'
          }
          type='website'
          author='First Citizens Bank'
        />
      )}

      {/*render page elements once data is available */}
      {isLoading ? (
        <Loading />
      ) : (
        docHomeDetails?.response && (
            <div id='docs-home-content'>
              <HomepageBannerNotification />
              <Markdown
                options={{
                  wrapper: Fragment,
                  overrides: {
                    Hero: {
                      component: DocsHero,
                      props: props,
                    },
                    FeatureCards: {
                      component: () => <></>,
                      // props: props,
                    },
                    SolutionDetailsApisInvolved: {
                      component: DocsHomeApisInvolved,
                      props: props,
                    },
                    SVBCTABlock: {
                      component: SVBCTABlock,
                      props: props,
                    },
                  },
                }}
              >
                {docHomeDetails?.response}
              </Markdown>
              {/* <div className='common-contextual-support'>
                  <SVBFaqApiContextualSupport 
                filterOption={{
                  resultCount : 3,
                  filterType: 'common',
                  filterValue: 'common',
                  filterDisplayName: 'common'
                }} 
                faqsData={supportFaqsItems} 
                extraClasses="container svb-container-fixed mb-10 pt-10 pb-10"
                />
                </div> */}
            </div>
        )
      )}
    </>
  );
};

export default DocsHome;
